<button
  (click)="showOverlay($event)"
  type="button"
  aria-haspopup="true"
  class="p-column-filter-menu-button p-link"
  [class.active-filter]="isActive"
  aria-expanded="false"
>
  <span class="pi pi-filter-icon pi pi-filter"></span>
</button>

<p-overlayPanel class="date-range-filter-overlay" #overlayPanel>
  <div class="d-flex flex-column gap-2" style="min-width: 240px">
    <label class="fw-bold mb-1">{{ column | translate }}</label>

    <p-calendar
      [(ngModel)]="_from"
      [maxDate]="_to"
      dateFormat="dd/mm/yy"
      placeholder="From"
      [showButtonBar]="true"
      [showIcon]="true"
      appendTo="body"
      inputStyleClass="form-control"
    ></p-calendar>

    <p-calendar
      [(ngModel)]="_to"
      [minDate]="_from"
      dateFormat="dd/mm/yy"
      placeholder="To"
      [showButtonBar]="true"
      [showIcon]="true"
      appendTo="body"
      inputStyleClass="form-control"
    ></p-calendar>

    <div class="d-flex justify-content-between gap-2 pt-2">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm flex-fill"
        (click)="onClear()"
      >
        Clear
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm flex-fill"
        (click)="onApply()"
      >
        Apply
      </button>
    </div>
  </div>
</p-overlayPanel>
